// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkflowNode_node__MPGof {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.WorkflowNode_node__MPGof:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  border-color: #007aff;
}

.WorkflowNode_handle__5eUeo {
  width: 10px !important;
  height: 10px !important;
  background-color: #555 !important;
  border: 2px solid white !important;
}

.WorkflowNode_placeholder__xFBZY {
  background-color: rgba(255, 255, 255, 0.7);
  border: 2px dashed #aaa;
  border-radius: 8px;
  padding: 10px;
  width: 150px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.WorkflowNode_placeholder__xFBZY:hover {
  background-color: rgba(230, 230, 250, 0.7);
  border-color: #88f;
}

.WorkflowNode_highlight__894Em {
  background: #e6f7ff;
  border-color: #1890ff;
  box-shadow: 0 0 0 4px rgba(24, 144, 255, 0.3);
  transform: scale(1.05);
  z-index: 10;
  animation: WorkflowNode_pulse__g19UZ 1.5s infinite;
}

@keyframes WorkflowNode_pulse__g19UZ {
  0% {
    box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.5);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(24, 144, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(24, 144, 255, 0);
  }
}

/* 트래시 아이콘 컨테이너 */
.WorkflowNode_trashIconContainer__FNt1B {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 10;
}

/* 트래시 아이콘 */
.WorkflowNode_trashIcon__L7LHl {
  cursor: pointer;
  color: #888;
  font-size: 14px;
  /* 기본 숨김 — 노드에 마우스를 올리거나 선택했을 때만 표시 (아래 규칙).
     visibility 를 0.3초 지연시켜, 노드 바깥(우상단 -16px)의 아이콘까지 마우스를 옮기는 동안
     엣지 상호작용 영역을 스치며 hover 가 잠깐 끊겨도 아이콘이 사라지지 않게 한다. */
  opacity: 0;
  visibility: hidden;
  transition: color 0.2s, opacity 0.15s, visibility 0s linear 0.3s;
}

/* 아이콘은 노드 바깥에 있지만 DOM 상 노드의 자식이라 노드 hover 가 그대로 적용된다 */
.react-flow__node:hover .WorkflowNode_trashIcon__L7LHl,
.react-flow__node.selected .WorkflowNode_trashIcon__L7LHl {
  opacity: 1;
  visibility: visible;
  transition-delay: 0s;
}

.WorkflowNode_trashIcon__L7LHl:hover {
  color: #f44;
}

/* 데이터 보기 아이콘 — 표시/숨김은 trashIcon 규칙을 같이 쓰고 hover 색만 다르다.
   선택자를 한 단계 높여 다크 테마의 .trashIcon 색 규칙보다 우선한다 */
.WorkflowNode_trashIcon__L7LHl.WorkflowNode_dataIcon__z80an:hover {
  color: #3b82f6;
}

/* 그룹 노드 스타일 */
.WorkflowNode_groupNode__hhfxn {
  position: relative;
  padding: 30px 8px 8px 8px;
  -webkit-user-select: none;
          user-select: none;
  background-color: rgba(240, 240, 240, 0.5);
  border: 2px dashed #1a192b;
  border-radius: 8px;
  cursor: grab !important;
  min-width: 240px;
  min-height: 140px;
  /* 내부 좌표계 설정 */
  transform-origin: top left;
  box-sizing: border-box; /* 명시적 크기 계산 방식 */
  z-index: 0 !important; /* 그룹 노드는 낮은 z-index를 가져야 함 */
  
  /* React Flow 기본 스타일 재정의 */
  width: 100% !important; 
  height: 100% !important;
}

/* React Flow 기본 그룹 노드 스타일 재정의를 위한 글로벌 CSS */
.react-flow__node-group {
  width: auto !important;
  height: auto !important;
  z-index: 0 !important; /* 명시적으로 낮은 z-index 설정 */
}

/* 그룹 노드 내부의 자식 노드에 대한 스타일 */
.react-flow__node[data-parent-id] {
  z-index: 10 !important; /* 부모보다 높은 z-index */
}

/* 서브플로/반복그룹 래퍼 — 크기는 노드 style 이 정한다 (고정 width/height 제거) */
.react-flow__node-subflow,
.react-flow__node-repeatGroup {
  z-index: 0 !important;
}

.WorkflowNode_groupNode__hhfxn:hover {
  background-color: rgba(240, 240, 240, 0.7);
}

.WorkflowNode_subflowNode__0RUFY {
  background-color: rgba(200, 230, 255, 0.5);
  border: 2px dashed #4a9eff;
  min-width: 320px; /* 서브플로우 노드 기본 크기 */
  min-height: 220px;
  padding: 35px 10px 10px 10px; /* 더 넓은 패딩 */
  /* 서브플로우 특성 강화 */
  background-image: linear-gradient(to bottom, rgba(200, 230, 255, 0.8), rgba(200, 230, 255, 0.4));
}

.WorkflowNode_subflowNode__0RUFY:hover {
  background-color: rgba(200, 230, 255, 0.7);
  border-color: #2a7eff;
  box-shadow: 0 0 0 1px rgba(42, 126, 255, 0.5);
}

.WorkflowNode_repeatGroupNode__3AOM4 {
  background-color: rgba(255, 220, 200, 0.5);
  border: 2px dashed #ff9d4a;
  min-width: 280px;
  min-height: 200px;
  /* 반복 그룹 특성 강화 */
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(255, 220, 200, 0.5),
    rgba(255, 220, 200, 0.5) 10px,
    rgba(255, 235, 220, 0.5) 10px,
    rgba(255, 235, 220, 0.5) 20px
  );
}

.WorkflowNode_repeatGroupNode__3AOM4:hover {
  background-color: rgba(255, 220, 200, 0.7);
  border-color: #ff8d2a;
  box-shadow: 0 0 0 1px rgba(255, 141, 42, 0.5);
}

/* 그룹 노드 헤더 */
.WorkflowNode_groupNodeHeader__W\\+GzP {
  position: absolute;
  top: 8px;
  left: 12px;
  font-weight: 500;
  font-size: 14px;
  width: calc(100% - 24px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  pointer-events: none; /* 헤더를 통과해서 이벤트 전달 */
  z-index: 10; /* 헤더가 항상 위에 보이도록 */
}

/* 그룹 노드 컨텐츠 영역 */
.WorkflowNode_groupNodeContent__aAenL {
  position: relative;
  width: 100%;
  height: calc(100% - 30px);
  margin-top: 20px;
  z-index: 1;
  /* 명확한 내부 패딩 설정 */
  padding: 10px;
  /* 명확한 포지셔닝 컨텍스트 생성 */
  transform-style: preserve-3d;
  box-sizing: border-box; /* 명시적 크기 계산 */
  /* 자식 노드 영역 표시를 위한 스타일 */
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

/* 그룹 노드가 드롭 타겟일 때의 스타일 */
.WorkflowNode_dropTarget__ngDfy {
  box-shadow: 0 0 0 2px #007aff;
  background-color: rgba(240, 240, 250, 0.8);
  border: 2px dashed #007aff !important;
  z-index: 100 !important; /* 드롭 타겟일 때 더 높은 z-index */
  animation: WorkflowNode_pulse__g19UZ 1.5s infinite !important;
}

/* 그룹 노드 드래그 오버 글로벌 스타일 */
.react-flow__node[data-is-group="true"].highlight,
.react-flow__node-subflow.highlight,
.react-flow__node-repeatGroup.highlight,
.react-flow__node-group.highlight {
  box-shadow: 0 0 8px 2px rgba(0, 122, 255, 0.7) !important;
  border: 2px dashed #007aff !important;
  background-color: rgba(230, 242, 255, 0.7) !important;
  transform: scale(1.02);
  transition: all 0.2s ease;
}

/* 부모 노드가 드래그 중일 때 자식 노드의 스타일 */
.WorkflowNode_parentDragging__vE5iJ {
  opacity: 0.6 !important;
  pointer-events: none !important;
  transition: transform 0.05s ease, opacity 0.2s ease !important;
  /* 자식 노드가 부모 위치를 따라가도록 설정 */
  transform: translate3d(0, 0, 0) !important;
  z-index: 4 !important; /* 부모 드래그 중에는 낮은 z-index */
  box-shadow: none !important;
  /* 드래그 중 표시 강화 */
  outline: 1px solid rgba(0, 0, 0, 0.05) !important;
  filter: grayscale(30%) !important;
}

/* 그룹 노드가 드래그 중일 때의 스타일 */
.WorkflowNode_groupDragging__eifw8 {
  cursor: grabbing !important;
  z-index: 1000 !important;
  opacity: 0.9 !important;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
  /* 드래그 중 더 명확한 시각적 피드백 */
  background-color: rgba(240, 240, 240, 0.8) !important;
  border: 2px solid rgba(0, 122, 255, 0.5) !important;
  /* 드래그 중 변환 최적화 */
  will-change: transform !important;
  transition: box-shadow 0.2s ease !important;
} 
/* ── 다크 테마 보정 (html.dark) ── */
.dark .WorkflowNode_handle__5eUeo {
  border-color: #1e1e1e !important;
  background-color: #9a9a9a !important;
}
.dark .WorkflowNode_placeholder__xFBZY {
  background-color: rgba(37, 37, 38, 0.85);
  border-color: #555555;
  color: #bbbbbb;
}
.dark .WorkflowNode_placeholder__xFBZY:hover {
  background-color: rgba(58, 58, 58, 0.9);
  border-color: #3794ff;
}
.dark .WorkflowNode_highlight__894Em {
  background: #094771;
  border-color: #3794ff;
}
.dark .WorkflowNode_trashIcon__L7LHl {
  color: #9a9a9a;
}
.dark .WorkflowNode_groupNode__hhfxn {
  background-color: rgba(37, 37, 38, 0.6);
  border-color: #555555;
}
.dark .WorkflowNode_groupNode__hhfxn:hover {
  background-color: rgba(37, 37, 38, 0.8);
}
.dark .WorkflowNode_subflowNode__0RUFY {
  background-color: rgba(23, 58, 82, 0.6);
  background-image: linear-gradient(to bottom, rgba(23, 58, 82, 0.8), rgba(23, 58, 82, 0.4));
}
.dark .WorkflowNode_repeatGroupNode__3AOM4 {
  background-color: rgba(82, 48, 36, 0.6);
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(82, 48, 36, 0.5),
    rgba(82, 48, 36, 0.5) 10px,
    rgba(100, 60, 44, 0.5) 10px,
    rgba(100, 60, 44, 0.5) 20px
  );
}
.dark .WorkflowNode_groupNodeContent__aAenL {
  background-color: rgba(255, 255, 255, 0.04);
}
.dark .WorkflowNode_dropTarget__ngDfy {
  background-color: rgba(37, 37, 38, 0.9);
}
.dark .react-flow__node[data-is-group="true"].highlight,
.dark .react-flow__node-subflow.highlight,
.dark .react-flow__node-repeatGroup.highlight,
.dark .react-flow__node-group.highlight {
  background-color: rgba(23, 58, 82, 0.8) !important;
}
.dark .WorkflowNode_groupDragging__eifw8 {
  background-color: rgba(37, 37, 38, 0.9) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/workflow/nodes/WorkflowNode.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,sBAAsB;EACtB,WAAW;EACX,kDAA8B;AAChC;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf;;sDAEoD;EACpD,UAAU;EACV,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA,uDAAuD;AACvD;;EAEE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;+CAC+C;AAC/C;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;EACjB,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,sBAAsB,EAAE,iBAAiB;EACzC,qBAAqB,EAAE,6BAA6B;;EAEpD,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB,EAAE,wBAAwB;AACjD;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB,EAAE,oBAAoB;AAC9C;;AAEA,2DAA2D;AAC3D;;EAEE,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,gBAAgB,EAAE,mBAAmB;EACrC,iBAAiB;EACjB,4BAA4B,EAAE,YAAY;EAC1C,gBAAgB;EAChB,gGAAgG;AAClG;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB;;;;;;GAMC;AACH;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB,EAAE,oBAAoB;EAC1C,WAAW,EAAE,mBAAmB;AAClC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB,EAAE,cAAc;EACtC,wBAAwB;EACxB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,0CAA0C;EAC1C,qCAAqC;EACrC,uBAAuB,EAAE,0BAA0B;EACnD,6DAAyC;AAC3C;;AAEA,yBAAyB;AACzB;;;;EAIE,yDAAyD;EACzD,qCAAqC;EACrC,qDAAqD;EACrD,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,8DAA8D;EAC9D,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB,EAAE,0BAA0B;EACjD,2BAA2B;EAC3B,gBAAgB;EAChB,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,oDAAoD;EACpD,wBAAwB;EACxB,qDAAqD;EACrD,mDAAmD;EACnD,iBAAiB;EACjB,iCAAiC;EACjC,2CAA2C;AAC7C;AACA,+BAA+B;AAC/B;EACE,gCAAgC;EAChC,oCAAoC;AACtC;AACA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;EACvC,0FAA0F;AAC5F;AACA;EACE,uCAAuC;EACvC;;;;;;GAMC;AACH;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,uCAAuC;AACzC;AACA;;;;EAIE,kDAAkD;AACpD;AACA;EACE,kDAAkD;AACpD","sourcesContent":[".node {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.node:hover {\r\n  box-shadow: 0 4px 16px rgba(0,0,0,0.15);\r\n  border-color: #007aff;\r\n}\r\n\r\n.handle {\r\n  width: 10px !important;\r\n  height: 10px !important;\r\n  background-color: #555 !important;\r\n  border: 2px solid white !important;\r\n}\r\n\r\n.placeholder {\r\n  background-color: rgba(255, 255, 255, 0.7);\r\n  border: 2px dashed #aaa;\r\n  border-radius: 8px;\r\n  padding: 10px;\r\n  width: 150px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.placeholder:hover {\r\n  background-color: rgba(230, 230, 250, 0.7);\r\n  border-color: #88f;\r\n}\r\n\r\n.highlight {\r\n  background: #e6f7ff;\r\n  border-color: #1890ff;\r\n  box-shadow: 0 0 0 4px rgba(24, 144, 255, 0.3);\r\n  transform: scale(1.05);\r\n  z-index: 10;\r\n  animation: pulse 1.5s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.5);\r\n  }\r\n  70% {\r\n    box-shadow: 0 0 0 6px rgba(24, 144, 255, 0);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 0 0 rgba(24, 144, 255, 0);\r\n  }\r\n}\r\n\r\n/* 트래시 아이콘 컨테이너 */\r\n.trashIconContainer {\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 5px;\r\n  z-index: 10;\r\n}\r\n\r\n/* 트래시 아이콘 */\r\n.trashIcon {\r\n  cursor: pointer;\r\n  color: #888;\r\n  font-size: 14px;\r\n  /* 기본 숨김 — 노드에 마우스를 올리거나 선택했을 때만 표시 (아래 규칙).\r\n     visibility 를 0.3초 지연시켜, 노드 바깥(우상단 -16px)의 아이콘까지 마우스를 옮기는 동안\r\n     엣지 상호작용 영역을 스치며 hover 가 잠깐 끊겨도 아이콘이 사라지지 않게 한다. */\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: color 0.2s, opacity 0.15s, visibility 0s linear 0.3s;\r\n}\r\n\r\n/* 아이콘은 노드 바깥에 있지만 DOM 상 노드의 자식이라 노드 hover 가 그대로 적용된다 */\r\n:global(.react-flow__node:hover) .trashIcon,\r\n:global(.react-flow__node.selected) .trashIcon {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  transition-delay: 0s;\r\n}\r\n\r\n.trashIcon:hover {\r\n  color: #f44;\r\n}\r\n\r\n/* 데이터 보기 아이콘 — 표시/숨김은 trashIcon 규칙을 같이 쓰고 hover 색만 다르다.\r\n   선택자를 한 단계 높여 다크 테마의 .trashIcon 색 규칙보다 우선한다 */\r\n.trashIcon.dataIcon:hover {\r\n  color: #3b82f6;\r\n}\r\n\r\n/* 그룹 노드 스타일 */\r\n.groupNode {\r\n  position: relative;\r\n  padding: 30px 8px 8px 8px;\r\n  user-select: none;\r\n  background-color: rgba(240, 240, 240, 0.5);\r\n  border: 2px dashed #1a192b;\r\n  border-radius: 8px;\r\n  cursor: grab !important;\r\n  min-width: 240px;\r\n  min-height: 140px;\r\n  /* 내부 좌표계 설정 */\r\n  transform-origin: top left;\r\n  box-sizing: border-box; /* 명시적 크기 계산 방식 */\r\n  z-index: 0 !important; /* 그룹 노드는 낮은 z-index를 가져야 함 */\r\n  \r\n  /* React Flow 기본 스타일 재정의 */\r\n  width: 100% !important; \r\n  height: 100% !important;\r\n}\r\n\r\n/* React Flow 기본 그룹 노드 스타일 재정의를 위한 글로벌 CSS */\r\n:global(.react-flow__node-group) {\r\n  width: auto !important;\r\n  height: auto !important;\r\n  z-index: 0 !important; /* 명시적으로 낮은 z-index 설정 */\r\n}\r\n\r\n/* 그룹 노드 내부의 자식 노드에 대한 스타일 */\r\n:global(.react-flow__node[data-parent-id]) {\r\n  z-index: 10 !important; /* 부모보다 높은 z-index */\r\n}\r\n\r\n/* 서브플로/반복그룹 래퍼 — 크기는 노드 style 이 정한다 (고정 width/height 제거) */\r\n:global(.react-flow__node-subflow),\r\n:global(.react-flow__node-repeatGroup) {\r\n  z-index: 0 !important;\r\n}\r\n\r\n.groupNode:hover {\r\n  background-color: rgba(240, 240, 240, 0.7);\r\n}\r\n\r\n.subflowNode {\r\n  background-color: rgba(200, 230, 255, 0.5);\r\n  border: 2px dashed #4a9eff;\r\n  min-width: 320px; /* 서브플로우 노드 기본 크기 */\r\n  min-height: 220px;\r\n  padding: 35px 10px 10px 10px; /* 더 넓은 패딩 */\r\n  /* 서브플로우 특성 강화 */\r\n  background-image: linear-gradient(to bottom, rgba(200, 230, 255, 0.8), rgba(200, 230, 255, 0.4));\r\n}\r\n\r\n.subflowNode:hover {\r\n  background-color: rgba(200, 230, 255, 0.7);\r\n  border-color: #2a7eff;\r\n  box-shadow: 0 0 0 1px rgba(42, 126, 255, 0.5);\r\n}\r\n\r\n.repeatGroupNode {\r\n  background-color: rgba(255, 220, 200, 0.5);\r\n  border: 2px dashed #ff9d4a;\r\n  min-width: 280px;\r\n  min-height: 200px;\r\n  /* 반복 그룹 특성 강화 */\r\n  background-image: repeating-linear-gradient(\r\n    -45deg,\r\n    rgba(255, 220, 200, 0.5),\r\n    rgba(255, 220, 200, 0.5) 10px,\r\n    rgba(255, 235, 220, 0.5) 10px,\r\n    rgba(255, 235, 220, 0.5) 20px\r\n  );\r\n}\r\n\r\n.repeatGroupNode:hover {\r\n  background-color: rgba(255, 220, 200, 0.7);\r\n  border-color: #ff8d2a;\r\n  box-shadow: 0 0 0 1px rgba(255, 141, 42, 0.5);\r\n}\r\n\r\n/* 그룹 노드 헤더 */\r\n.groupNodeHeader {\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 12px;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  width: calc(100% - 24px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  pointer-events: none; /* 헤더를 통과해서 이벤트 전달 */\r\n  z-index: 10; /* 헤더가 항상 위에 보이도록 */\r\n}\r\n\r\n/* 그룹 노드 컨텐츠 영역 */\r\n.groupNodeContent {\r\n  position: relative;\r\n  width: 100%;\r\n  height: calc(100% - 30px);\r\n  margin-top: 20px;\r\n  z-index: 1;\r\n  /* 명확한 내부 패딩 설정 */\r\n  padding: 10px;\r\n  /* 명확한 포지셔닝 컨텍스트 생성 */\r\n  transform-style: preserve-3d;\r\n  box-sizing: border-box; /* 명시적 크기 계산 */\r\n  /* 자식 노드 영역 표시를 위한 스타일 */\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n}\r\n\r\n/* 그룹 노드가 드롭 타겟일 때의 스타일 */\r\n.dropTarget {\r\n  box-shadow: 0 0 0 2px #007aff;\r\n  background-color: rgba(240, 240, 250, 0.8);\r\n  border: 2px dashed #007aff !important;\r\n  z-index: 100 !important; /* 드롭 타겟일 때 더 높은 z-index */\r\n  animation: pulse 1.5s infinite !important;\r\n}\r\n\r\n/* 그룹 노드 드래그 오버 글로벌 스타일 */\r\n:global(.react-flow__node[data-is-group=\"true\"].highlight),\r\n:global(.react-flow__node-subflow.highlight),\r\n:global(.react-flow__node-repeatGroup.highlight),\r\n:global(.react-flow__node-group.highlight) {\r\n  box-shadow: 0 0 8px 2px rgba(0, 122, 255, 0.7) !important;\r\n  border: 2px dashed #007aff !important;\r\n  background-color: rgba(230, 242, 255, 0.7) !important;\r\n  transform: scale(1.02);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n/* 부모 노드가 드래그 중일 때 자식 노드의 스타일 */\r\n.parentDragging {\r\n  opacity: 0.6 !important;\r\n  pointer-events: none !important;\r\n  transition: transform 0.05s ease, opacity 0.2s ease !important;\r\n  /* 자식 노드가 부모 위치를 따라가도록 설정 */\r\n  transform: translate3d(0, 0, 0) !important;\r\n  z-index: 4 !important; /* 부모 드래그 중에는 낮은 z-index */\r\n  box-shadow: none !important;\r\n  /* 드래그 중 표시 강화 */\r\n  outline: 1px solid rgba(0, 0, 0, 0.05) !important;\r\n  filter: grayscale(30%) !important;\r\n}\r\n\r\n/* 그룹 노드가 드래그 중일 때의 스타일 */\r\n.groupDragging {\r\n  cursor: grabbing !important;\r\n  z-index: 1000 !important;\r\n  opacity: 0.9 !important;\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;\r\n  /* 드래그 중 더 명확한 시각적 피드백 */\r\n  background-color: rgba(240, 240, 240, 0.8) !important;\r\n  border: 2px solid rgba(0, 122, 255, 0.5) !important;\r\n  /* 드래그 중 변환 최적화 */\r\n  will-change: transform !important;\r\n  transition: box-shadow 0.2s ease !important;\r\n} \r\n/* ── 다크 테마 보정 (html.dark) ── */\r\n:global(.dark) .handle {\r\n  border-color: #1e1e1e !important;\r\n  background-color: #9a9a9a !important;\r\n}\r\n:global(.dark) .placeholder {\r\n  background-color: rgba(37, 37, 38, 0.85);\r\n  border-color: #555555;\r\n  color: #bbbbbb;\r\n}\r\n:global(.dark) .placeholder:hover {\r\n  background-color: rgba(58, 58, 58, 0.9);\r\n  border-color: #3794ff;\r\n}\r\n:global(.dark) .highlight {\r\n  background: #094771;\r\n  border-color: #3794ff;\r\n}\r\n:global(.dark) .trashIcon {\r\n  color: #9a9a9a;\r\n}\r\n:global(.dark) .groupNode {\r\n  background-color: rgba(37, 37, 38, 0.6);\r\n  border-color: #555555;\r\n}\r\n:global(.dark) .groupNode:hover {\r\n  background-color: rgba(37, 37, 38, 0.8);\r\n}\r\n:global(.dark) .subflowNode {\r\n  background-color: rgba(23, 58, 82, 0.6);\r\n  background-image: linear-gradient(to bottom, rgba(23, 58, 82, 0.8), rgba(23, 58, 82, 0.4));\r\n}\r\n:global(.dark) .repeatGroupNode {\r\n  background-color: rgba(82, 48, 36, 0.6);\r\n  background-image: repeating-linear-gradient(\r\n    -45deg,\r\n    rgba(82, 48, 36, 0.5),\r\n    rgba(82, 48, 36, 0.5) 10px,\r\n    rgba(100, 60, 44, 0.5) 10px,\r\n    rgba(100, 60, 44, 0.5) 20px\r\n  );\r\n}\r\n:global(.dark) .groupNodeContent {\r\n  background-color: rgba(255, 255, 255, 0.04);\r\n}\r\n:global(.dark) .dropTarget {\r\n  background-color: rgba(37, 37, 38, 0.9);\r\n}\r\n:global(.dark) :global(.react-flow__node[data-is-group=\"true\"].highlight),\r\n:global(.dark) :global(.react-flow__node-subflow.highlight),\r\n:global(.dark) :global(.react-flow__node-repeatGroup.highlight),\r\n:global(.dark) :global(.react-flow__node-group.highlight) {\r\n  background-color: rgba(23, 58, 82, 0.8) !important;\r\n}\r\n:global(.dark) .groupDragging {\r\n  background-color: rgba(37, 37, 38, 0.9) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"node": `WorkflowNode_node__MPGof`,
	"handle": `WorkflowNode_handle__5eUeo`,
	"placeholder": `WorkflowNode_placeholder__xFBZY`,
	"highlight": `WorkflowNode_highlight__894Em`,
	"pulse": `WorkflowNode_pulse__g19UZ`,
	"trashIconContainer": `WorkflowNode_trashIconContainer__FNt1B`,
	"trashIcon": `WorkflowNode_trashIcon__L7LHl`,
	"dataIcon": `WorkflowNode_dataIcon__z80an`,
	"groupNode": `WorkflowNode_groupNode__hhfxn`,
	"subflowNode": `WorkflowNode_subflowNode__0RUFY`,
	"repeatGroupNode": `WorkflowNode_repeatGroupNode__3AOM4`,
	"groupNodeHeader": `WorkflowNode_groupNodeHeader__W+GzP`,
	"groupNodeContent": `WorkflowNode_groupNodeContent__aAenL`,
	"dropTarget": `WorkflowNode_dropTarget__ngDfy`,
	"parentDragging": `WorkflowNode_parentDragging__vE5iJ`,
	"groupDragging": `WorkflowNode_groupDragging__eifw8`
};
export default ___CSS_LOADER_EXPORT___;
